
class ConnectionProductUIHandler {

    productSrv: ConnectionProductService
    applicationType: number

    constructor(srv: ConnectionProductService, applicationType: number) {
        this.productSrv = srv;
        this.applicationType = applicationType;
    }

    init() {
        this.productSrv.initConnectionProducts().done((result) => this.registerConnectionProductUiEvents(result));
    }

    registerConnectionProductUiEvents(result) {
        $(".productTypeButton").click((e) => this.handleProductTypeButtonClick(e));

        $(".connectionProductHolder").on("change", "select, input", (e) => this.handleConnectionProductChange(e)); 
    }

    handleProductTypeButtonClick(e) {
        var sender = $(e.currentTarget);
        var type = sender.data("type");
        if (type === 2) {
            // gas removed, only one product remains and should not be selectable
            this.productSrv.setSelectedConnectionProduct(21, true).done((result) => { console.log(result); });
        }
        this.handleConnectionProductTypeSelection(type, sender);
        // need some logic to change button states
        //console.log($(e.currentTarget), e.currentTarget);
        //console.log($(e.currentTarget).hasClass("active"));
    }

    handleProductTypeButtonState(target) {
        if (target.hasClass("active")) {
            target.removeClass("active");
            return false;
        } else {
            target.addClass("active");
            return true;
        }
    }

    handleConnectionProductTypeSelection(type: number, sender: object) {
        console.log("handleConnectionProductTypeSelection", type);
        var productTypeElement = null;
        var productForm = null;
        switch (type) {
            case 1:
                productTypeElement = $("#electricityProductsHolder");
                productForm = document.getElementById("electricityProductForm");
                break;
            case 2:
                productTypeElement = $("#heatProductsHolder");
                productForm = document.getElementById("heatProductForm");
                break;
            case 3:
                productTypeElement = $("#waterProductsHolder");
                productForm = document.getElementById("waterProductForm");
                break;
            default:
        }
        //check if type is selected or unselected
        // var isSelected = !productTypeElement.is(":visible");
        var isSelected = this.handleProductTypeButtonState(sender);

        if (this.applicationType == 3 || this.applicationType == 4) {
            this.productSrv.setSelectedConnectionProductTypeAndSelectFirstProduct(type, isSelected);
        } else {
            this.productSrv.setSelectedConnectionProductType(isSelected, type).always((result: boolean) => this.handleSetSelectedConnectionProductTypeResult(result, type));
        }
        if (!isSelected) {
            productForm.reset();
        }
        //toggle visibility
        productTypeElement.toggle();
    }

    handleSetSelectedConnectionProductTypeResult(result: boolean, type: number) {
        console.log("handleSetSelectedConnectionProductTypeResult", result);
        console.log("getting connectioproducts by type " + type);
        this.productSrv.getConnectionProductsSorted(type, 1).done((data) => this.updateConnectionProductsOnUI(data, type));
    }

    updateConnectionProductsOnUI(data: any, type: number) {
        console.log("updateConnectionProductsOnUI", data);
        var element = null;
        var template = null;
        switch (type) {
            case 1:
                element = $("[name='electricity-ConnectionSize']");
                template = $("#connectionProductOptionElectricityTemplate");
                break;
            case 2:
                element = $("[name='HeatingProduct']");
                template = $("#connectionProductOptionHeatingTemplate");
                break;
            case 3:
                element = $("#waterProducts");
                template = $("#connectionProductWaterTemplate");
                break;
            default:
        }
        element.empty();
        var products = { data: data }
        template.tmpl(products).appendTo(element);
    }

    handleConnectionProductChange(e) {
        var sender = $(e.currentTarget);
        var value = sender.val();
        var type = sender.data("type");
        var isSelected = true;
        if (sender.is(':checkbox')) {
            isSelected = sender.is(":checked");
        }
        this.productSrv.setSelectedConnectionProduct(value, isSelected).done((result) => { console.log(result);});
    }
}